<!--
 * @Autor: chentianyang
 * @Date: 2021-07-27 10:43:52
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-09-05 15:31:29
 * @FilePath: /teacher-h5/src/App.vue
-->
<template>
  <a-config-provider :locale="zh_CN">
    <a-spin
      v-if="globalSpinning"
      style="margin: 45vh auto;width: 100%;"
      :spinning="globalSpinning"
      tip="加载中..."
      size="large"
    />
    <div id="app" v-if="!globalSpinning">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
      <!-- 组员变更消息弹窗 -->
      <groupMsgModal :visible.sync="visible" />
    </div>
  </a-config-provider>
</template>
<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { tkSdkNew } from '@/utils/tools.js'
import groupMsgModal from '@/components/groupMsgModal'
import { mapGetters } from 'vuex'

export default {
  name: 'App',

  components: {
    groupMsgModal
  },

  data() {
    return {
      visible: false,
      zh_CN
    }
  },
  created() {
    tkSdkNew.loadAllMathjax()
  },

  computed: {
    ...mapGetters({
      msgArr: 'common/groupMsgArr',
      globalSpinning: 'common/globalSpinning'
    })
  },

  watch: {
    msgArr(arr) {
      if (arr.length > 0) {
        setTimeout(() => {
          this.visible = true
        }, 500)
      }
    }
  }
}
</script>
<style lang="less">
@import '~@/static/css/reset.less';
@import '~ant-design-vue/dist/antd.less';
@import '~@/static/css/base.less';
@import '~@/static/css/antd-theme/index.less';

body, #app {
  height: 100%;
  width: 100%;
  overflow: hidden;
  color: @gray-2;
  background: @gray-8;
  // 禁止滑动
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
}
// 手写分数，包含 0123456789. 十一个字符
@font-face {
  font-family: "Score-Num";
  src: url('./static/fonts/score/Score-Num.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

</style>
